import { getAviosBasePathEnvValue } from '@reward-platform/platform-config'
import { createPathname } from '@reward-platform/utils'
import { useMemo } from 'react'

/**
 * uses base path if set for all asset prefixes, regardless of whitelabel
 * this is configured in the next.config.js file
 */
export const getPublicAssetSrc = (src: string) => {
  const basePath = getAviosBasePathEnvValue()
  return createPathname(src, basePath)
}

export function usePublicAssetSrc(src: string) {
  return useMemo(() => getPublicAssetSrc(src), [src])
}
